export default __webpack_public_path__ + "static/media/avatar-branco.ea4d9e01.svg";